export default function(_el) {

  const showDetails = _el.querySelector('[data-js-show-details]');
  showDetails?.addEventListener('click', e => {
    e.preventDefault();
    _el.classList.add('show-details');
  });

  const hideDetails = _el.querySelector('[data-js-hide-details]');
  hideDetails?.addEventListener('click', e => {
    e.preventDefault();
    _el.classList.remove('show-details');
  });
}